<template>
    <b-tabs
        pills
        vertical
        class="apprentice-pills-tab slu-settings-tab"
        nav-wrapper-class="col-12 col-lg-3 col-xl-2 d-none d-lg-block"
        content-class="col-12 col-lg-9 col-xl-10 group-show-tools-tab-content"
    >
        <b-tab :title="$t('slu_dashboard.general_settings')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <i class="fas fa-cogs fa-fw"></i>{{$t('slu_dashboard.general_settings')}}
                    </div>
                </div>
            </template>
            <design-2021-slu-dashboard-common-settings-tab-component
                :slu-school-settings-in="sluSchoolSettingsIn"
            >
            </design-2021-slu-dashboard-common-settings-tab-component>
        </b-tab>
        <b-tab :title="$t('slu_dashboard.statuses')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <i class="fas fa-tools fa-fw"></i>{{$t('slu_dashboard.options')}}
                    </div>
                </div>
            </template>
            <design-2021-slu-dashboard-status-tags-tab-component
                :slu-status-tags-in="sluStatusTagsIn"
                :slu-school-settings-in="sluSchoolSettingsIn"
            >
            </design-2021-slu-dashboard-status-tags-tab-component>
        </b-tab>
        <b-tab title="Labels">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <i class="fas fa-sticky-note fa-fw"></i>Labels
                    </div>
                </div>
            </template>
            <design-2021-slu-dashboard-labels-tab-component
                :slu-labels-in="sluLabelsIn">
            </design-2021-slu-dashboard-labels-tab-component>
        </b-tab>
        <b-tab :title="$t('slu_dashboard.administrators')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title">
                        <i class="fas fa-user fa-fw"></i>{{$t('slu_dashboard.administrators')}}
                    </div>
                </div>
            </template>
            <design-2021-slu-dashboard-managers-tab-component
                :slu-managers-in="sluManagersIn"
            >
            </design-2021-slu-dashboard-managers-tab-component>
        </b-tab>

    </b-tabs>
</template>

<script>
export default {
    name: "design-2021-slu-dashboard-settings-tab-component",
    props: ['sluSchoolSettingsIn','sluStatusTagsIn','sluManagersIn','sluLabelsIn']
}
</script>

<style scoped>
</style>
